export default __webpack_public_path__ + "static/media/23_b.o._roses.25489935.png";